// App.js
import React from "react";
import "./assets/styles/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import HeroSection from "./components/HeroSection/HeroSection";
import WhyIndiaSection from "./components/WhyIndiaSection/WhyIndiaSection";
import WhatWeDoSection from "./components/WhatWeDoSection/WhatWeDoSection";
import PlansSection from "./components/PlansSection/PlansSection";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import BonusGuarantees from "./components/BonusGuarantees/BonusGuarantees";
import WhoThisIsFor from "./components/WhoThisIsFor/WhoThisIsFor";
import About from "./Pages/About/About";  
import SourcingServices from "./Pages/SourcingServices/SourcingServices"; 
import FaqSection from "./Pages/FaqSection/FaqSection";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService/TermsOfService";
import RefundPolicy from "./Pages/RefundPolicy/RefundPolicy"; 
import Contact from "./Pages/Contact/Contact";
import LearnMore from "./Pages/LearnMore/LearnMore";
import SellInIndiaForm from "./Pages/SellInIndiaForm/SellInIndiaForm";
import SourcingRequestForm from "./Pages/SourcingRequestForm/SourcingRequestForm";// adjust path as needed
 // adjust path as needed


const App = () => {
  return (
    <Router>
      <Header />
      <Routes>
        {/* ✅ Home Page with all sections */}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <WhyIndiaSection />
              <WhatWeDoSection />
              <PlansSection />
              <HowItWorks />
              <BonusGuarantees />
              <WhoThisIsFor />
            </>
          }
        />

        {/* ✅ About Page Route */}
        <Route path="/about" element={<About />} />
         <Route path="/SourcingServices" element={<SourcingServices />} />
         <Route path="/FaqSection" element={<FaqSection />} />
         <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfService" element={<TermsOfService />} />
          <Route path="/RefundPolicy" element={<RefundPolicy />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/LearnMore" element={<LearnMore />} />
          <Route path="/SellInIndiaForm" element={<SellInIndiaForm />} />
          <Route path="/SourcingRequestForm" element={<SourcingRequestForm />} />

          


         
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
